<template>
  <div class="d-flex bg-white py-3 px-4 border rounded">
    <div class="mr-2" style="width: 200px;">
      <div class="text-secondary mb-1" style="font-size: 0.8rem">
        Название
      </div>
      <div class="font-weight-bold text-break">
        {{ queue.name || 'Без названия' }}
      </div>
    </div>

    <div class="mr-4" style="width: 300px;">
      <div class="text-secondary mb-1" style="font-size: 0.8rem">
        Описание
      </div>
      <div>
        {{ queue.description || 'Без описания' }}
      </div>
    </div>

    <div class="mr-4" style="width: 300px;">
      <div class="text-secondary mb-1" style="font-size: 0.8rem">
        ID очереди
      </div>
      <div>
        {{ queue.id || 'Без id' }}
      </div>
    </div>

    <div class="d-flex flex-column ml-auto">
      <b-button variant="primary" size="sm" @click="openEditModal">
        Редактировать
      </b-button>

      <b-button
        variant="danger"
        class="mt-2"
        size="sm"
        @click="openDeleteModal"
      >
        Удалить
      </b-button>
    </div>
  </div>
</template>

<script>
import Bus from '@/eventBus';

export default {
  name: 'QueueInfo',
  props: {
    queue: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    openEditModal() {
      this.$store.commit(this.$types.OPEN_MODAL, {
        name: 'QueueEditModal',
        props: {
          queue: this.queue,
          afterSave: () => Bus.$emit('queues:fetch'),
        },
      });
    },
    openDeleteModal() {
      this.$store.commit(this.$types.OPEN_MODAL, {
        name: 'QueueDeleteModal',
        props: {
          queueId: this.queue.id,
          afterDelete: () => Bus.$emit('queues:fetch'),
        },
      });
    },
  },
};
</script>
